import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// Self-hosted Inter. The stylesheet has always asked for Inter first, but the
// font was never shipped, so every visitor saw their system font instead and
// the site's typography never actually changed between designs.
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/inter/800.css";
import { App } from "./App";
import { mindsetAccountExperienceAdapter } from "./accountExperienceAdapter";
import { isPublicMarketingHost } from "./publicHosts";
import "./styles.css";
import "./publicRedesign.css";

const stopSessionRefresh = isPublicMarketingHost() ? () => undefined : mindsetAccountExperienceAdapter.startSessionRefresh();
window.addEventListener("pagehide", stopSessionRefresh, { once: true });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
